import React, { Component } from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import { Button, Card, Form, notification, Popconfirm, Tabs, Tooltip, Row, Col, Icon, Drawer, DatePicker } from 'antd'
import { TableComp, FormUtils as GetAllFormFields } from 'sz-react-utils'
import Request from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'

import { RightsWrapper } from '../../../components/_utils/utils'
import ReceiptView from '../../../components/DocumentViews/receiptView';
const TabPane = Tabs.TabPane
const { RangePicker } = DatePicker
let dateFormat = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).dateFormat : 'DD.MM.YYYY';
let accountPaymentCompanies = localStorage.getItem('company-details') ? JSON.parse(localStorage.getItem('company-details')).accountPaymentCompanies : '';

@Form.create()
class RequestUpdationForm extends Component {
  state = {
    visible: true,
    fields: [{ display: 'Date Of Birth', _id: 'dob' }, { display: 'Payment Date', _id: 'paymentDate' }, { display: 'Student Name', _id: 'studentName' }, { display: 'Amount', _id: 'totalAmount' }],
    fieldName: null,
    loading: false
  }

  onClose = () => {
    this.setState({
      visible: false
    })
    setTimeout(() => {
      this.props.onClose();
    }, 50)
  }

  handleSubmit = (e) => {
    const { form } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      let values = _.clone(valData);
      values.recordId = this.props.recordId;
      this.setState({ loading: true });
      let response = await Request.addAccountPaymentUpdateRequest(values);
      this.setState({ loading: false });
      if (response.success) {
        notification.success({
          message: response.message
        })
      } else {
        notification.error({
          message: response.message
        })
      }
      this.onClose();
    })
  }

  render() {
    let { visible } = this.state;
    let { form: { getFieldDecorator } } = this.props;

    const fieldNames = {
      "dob": "date",
      "paymentDate": "date",
      "studentName": "text",
      "totalAmount": "number"
    }

    const inputTypes = {
      fields: [
        {
          label: 'Field To Update',
          key: 'fieldName',
          type: 'select',
          options: this.state.fields,
          required: true,
          onChange: value => {
            this.props.form.setFieldsValue({ fieldName: value }, () => {
              this.setState({ fieldName: value })
            });
          }
        },
        {
          label: 'New Field Value',
          key: 'newValue',
          type: fieldNames[this.state.fieldName], // dynamic type
          hidden: !this.state.fieldName,
          required: this.state.fieldName,
        },
        {
          label: 'Reason',
          key: 'reasonForUpdation',
          type: 'textarea',
          hidden: !this.state.fieldName,
          required: this.state.fieldName,
        }
      ]
    };


    return (
      <Drawer title=""
        placement="right"
        closable={true}
        onClose={this.onClose}
        visible={visible}
        width={600}>
        <Card bordered={true} title="Update Details">
          <Form onSubmit={this.handleSubmit}>
            <GetAllFormFields
              inputSchema={inputTypes}
              getFieldDecorator={getFieldDecorator}
            />
            <Button
              type=""
              htmlType="submit"
              style={{
                marginBottom: 10,
                marginLeft: '33%',
                backgroundColor: 'green',
                color: 'white'
              }}
              loading={this.props.loading}>
              SAVE
            </Button>
          </Form>
        </Card>
      </Drawer>
    )
  }
}




@Form.create()
class AllAccountPayments extends Component {
  state = {
    id: '',
    total: 0,
    amountTotal: 0,
    activeTab: '0',
    refreshChild: false,
    showAccountPaymentDrawar: false,
    recordId: '',
    showRequestUpdationForm: false,
    dataSource: [],
    time: {
      from: moment().startOf('day'),
      to: moment().endOf('day')
    }
  }

  apiRequest = params => {
    return new Promise(async resolve => {
      this.setState({ exportParams: params })
      if (!params.sortField) {
        params.sortField = 'createdDate'
        params.sortOrder = 'descend'
      }
      if (this.state.time && this.state.time.from && this.state.time.to) {
        params.time = this.state.time;
      }
      let data = await Request.getAccountPaymentDetails({
        ...params,
        regExFilters: ['studentName', 'amountType', 'paymentType', 'studentMobile', 'studentId', 'dob', 'passportNo', 'paymentCompany']
      })
      this.setState({ total: data.total, amountTotal: data.totalAmount, dataSource: data.data })
      resolve(data)
    })
  }
  handleSubmit = e => {
    const { form } = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = null
        if (this.state.id) {
          values._id = this.state.id
          x = await Request.updateAccountPaymentDetails(values)
        } else {
          x = await Request.addAccountPaymentDetails(values)
        }

        if (!x.error) {
          this.setState({
            id: '',
            activeTab: '0',
          })
          notification.success({
            message: this.state.id
              ? `Account Payment Updated Successfully`
              : 'Account Payment Added successfully'
          })
          if (!this.state.id) {
            form.resetFields()
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }
  deleteAccountPaymentDetails = async data => {
    this.setState({ loading: true })
    let deleteReason = prompt('Reason for deleting');
    if (!deleteReason) {
      notification.error({
        message: 'Enter Reason for deleting',
      })
      return;
    }
    data.deleteReason = deleteReason;
    await Request.deleteAccountPaymentDetails(data)

    this.setState({ loading: false })

    this.table.current.reload()

    notification.success({
      message: 'Deleted Successfully',
      duration: 20,
      key: `${data._id}-close`
    })
  }
  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }
  setAccountPaymentDetailsData(accountPaymentId) {
    if (accountPaymentId) {
      Request.accountPaymentDetailsByID({ id: accountPaymentId }).then(
        ({ doc, error, message }) => {
          if (!error && doc) {
            this.setState({
              id: doc._id,
              activeTab: '1'
            })

            this.props.form.setFieldsValue({
              amountType: doc.amountType,
              paymentCompany: doc.paymentCompany,
              paymentType: doc.paymentType,
              ApplyGST: doc.ApplyGST,
              generateReceipt: doc.generateReceipt,
              studentName: doc.studentName,
              studentMobile: doc.studentMobile,
              studentId: doc.studentId,
              dob: doc.dob,
              receiptNumber: doc.receiptNumber,
              totalAmount: doc.totalAmount,
              remarks: doc.remarks,
            })
          } else {
            notification.error({
              message: 'Error Getting Data',
              description: message
            })
          }
        }
      )
    }
  }

  viewAccountPaymentReceipt = (recordId) => {
    this.setState({
      showAccountPaymentDrawar: true,
      recordId: recordId
    })
  }

  closeDocument = () => {
    this.setState({ showAccountPaymentDrawar: false });
  }

  closeUpdationForm = () => {
    this.setState({ showRequestUpdationForm: false, recordId: null }, () => {
      this.table.current.reload();
    });
  }


  sendAccountPaymentReceipt = async (recordId) => {
    this.setState({ loading: true })
    await Request.sendAccountPaymentDetails(recordId)

    this.setState({ loading: false })

    this.table.current.reload()

    notification.success({
      message: 'Sent Successfully',
      duration: 20
    })
  }

  refreshFxn = () => {
    this.setState({ refreshChild: !this.state.refreshChild })
  }
  componentWillMount() {
  }
  async componentDidMount() {
  }
  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
      activeTab: value
    })
  }

  requestAccountUpdate = async (recordId) => {
    this.setState({ showRequestUpdationForm: true, recordId: recordId });
  }

  approveAccountPayment = async (recordId) => {
    let response = await Request.approveAccountPayment({ _id: recordId })
    if (response.success) {
      notification.success({
        message: response.message
      })
    } else {
      notification.error({
        message: response.message
      })
    }
    this.table.current.reload()
  }

  chooseRangerPicker = (date, dateString) => {
    this.setState(
      {
        time: {
          from: date[0] ? moment(date[0]).startOf('day') : null,
          to: date[1] ? moment(date[1]).endOf('day') : null
        }
      }, () => {
        if (this.table && this.table.current) {
          this.table.current.reload();
        }
      }
    )
  }

  onOk = value => {
    if (this.table && this.table.current) {
      this.table.current.reload();
    }
  }

  render() {
    const {
      form: { getFieldDecorator }
    } = this.props
    const { id, showAccountPaymentDrawar, recordId, showRequestUpdationForm, time } = this.state;
    let accountPaymentCompaniesArray = [];
    if (accountPaymentCompanies.indexOf(',')) {
      accountPaymentCompaniesArray = accountPaymentCompanies.split(',');
    }
    const inputTypes = {
      fields: [
        {
          label: 'Amount Type',
          key: 'amountType',
          required: true,
          type: 'select',
          options: [
            'Consultancy Fees',
            'French Fees',
            'Application Fees',
            'VISA/EMBASSY/SOP',
            'IELTS Fees',
            'PTE Fees',
            'Test Booking'
          ],
          onChange: v => {
            this.props.form.setFieldsValue({ amountType: v, remarks: v })
          }
        },
        {
          label: 'Company',
          key: 'paymentCompany',
          required: true,
          type: 'select',
          options: accountPaymentCompaniesArray,
          onChange: v => {
            this.props.form.setFieldsValue({ paymentCompany: v })
          }
        },
        {
          label: 'Student Name',
          key: 'studentName',
          required: true
        },
        {
          label: 'Student Mobile',
          key: 'studentMobile',
          required: true
        },
        {
          label: 'VID',
          key: 'studentId'
        },
        {
          label: 'Passport Number',
          key: 'passportNo'
        },
        {
          label: 'DOB',
          key: 'dob',
          type: 'text',
          customProps: {
            style: {
              width: '100%'
            }
          },
          required: true,

        },
        {
          label: 'Receipt Number',
          key: 'receiptNumber',
          type: 'number',
          customProps: {
            style: {
              width: '100%'
            }
          },
          required: (this.state.total > 0 ? false : true),
          hidden: (this.state.total > 0 ? true : false)
        },
        {
          label: 'Apply GST',
          key: 'ApplyGST',
          required: true,
          type: 'select',
          options: [
            'Yes',
            'No'
          ],
          onChange: v => {
            this.props.form.setFieldsValue({ ApplyGST: v })
          }
        },
        {
          label: 'Generate Receipt',
          key: 'generateReceipt',
          required: true,
          type: 'select',
          options: [
            'Yes',
            'No'
          ],
          onChange: v => {
            this.props.form.setFieldsValue({ generateReceipt: v })
          }
        },
        {
          label: 'Date of Receipt',
          key: 'dateOfReceipt',
          type: 'date',
          required: true,
        },
        {
          label: 'Payment Type',
          key: 'paymentType',
          required: true,
          type: 'select',
          options: [
            'Cash',
            'Transfer'
          ],
          onChange: v => {
            this.props.form.setFieldsValue({ paymentType: v })
          }
        },
        {
          label: 'Amount',
          key: 'totalAmount',
          type: 'number',
          customProps: {
            style: {
              width: '100%'
            }
          },
          required: true
        },
        {
          label: 'Remarks',
          key: 'remarks',
          type: 'textarea'
        }
      ]
    };

    const columns = [
      {
        title: '#',
        key: 'serialNumber',
        width: 40,
        render: (text, record, index) => (
          <div>{this.state.dataSource.length - index}</div>
        )
      },
      // {
      //   title: 'Created By',
      //   key: 'lastUpdatedByName',
      //   dataIndex: 'lastUpdatedByName',
      //   render: (text, record) => {
      //     return (
      //       <div>
      //         <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
      //         <small>{record.createdDate ? moment(record.createdDate).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : ''}</small>
      //         {/* <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : ''}</small> */}
      //       </div>
      //     )
      //   }
      // },
      // {
      //   title: 'Created By',
      //   key: 'lastUpdatedByName',
      //   dataIndex: 'lastUpdatedByName',
      //   render: (text, record) => {
      //     return (
      //       <div>
      //         <div>
      //           {record.updatedByUser != null
      //             ? record.updatedByUser.name
      //             : record.createdByUser != null
      //               ? record.createdByUser.name
      //               : ""}
      //         </div>

      //         <small>
      //           {record.createdDate
      //             ? moment(record.createdDate).format('DD MMM YYYY, HH:mm')
      //             : record.createdByUser
      //               ? moment(record.createdByUser.time).format('DD MMM YYYY, HH:mm')
      //               : ''}
      //         </small>
      //       </div>
      //     )
      //   }
      // },
      {
        title: 'Created By',
        key: 'lastUpdatedByName',
        dataIndex: 'lastUpdatedByName',
        render: (text, record) => {
          return (
            <div>
              {/* User Name Section */}
              <div style={{ fontWeight: 500 }}>
                {record.updatedByUser != null
                  ? record.updatedByUser.name
                  : record.createdByUser != null
                    ? record.createdByUser.name
                    : ""}
              </div>

              {/* Date Section */}
              <small style={{ color: '#8c8c8c', display: 'block', marginBottom: '4px' }}>
                {record.createdDate
                  ? moment(record.createdDate).format('DD MMM YYYY, HH:mm')
                  : record.createdByUser
                    ? moment(record.createdByUser.time).format('DD MMM YYYY, HH:mm')
                    : ''}
              </small>

              {/* ✅ Update Records Reason Section (Red Color) */}
              {record.update_records &&
                record.update_records.length > 0 &&
                record.update_records.map((update, index) => {

                  if (
                    update.fieldName === 'paymentDate' &&
                    update.status === 'Approved'
                  ) {
                    return (
                      <div key={index} style={{ marginTop: '4px' }}>
                        <div
                          style={{
                            color: '#ff4d4f',
                            fontSize: '11px',
                            fontWeight: 500
                          }}
                        >
                          Payment Date: {moment(update.newValue).format(dateFormat)}
                        </div>
                      </div>
                    );
                  }

                  return null;
                })}
            </div>
          )
        }
      },
      {
        title: 'Service',
        key: 'amountType',
        filters: [{ text: 'Visitor Consultancy Fees', value: 'Visitor Consultancy Fees' }, { text: 'Consultancy Fees', value: 'Consultancy Fees' }, { text: 'Application Fees', value: 'Application Fees' }, { text: 'IELTS Fees', value: 'IELTS Fees' }, { text: 'PTE Fees', value: 'PTE Fees' }, { text: 'TOEFL Fees', value: 'TOEFL Fees' }, { text: 'VISA/EMBASSY/SOP', value: 'VISA/EMBASSY/SOP' }],
        filterRegex: true
      },
      {
        title: 'Company',
        key: 'paymentCompany',
        filters: accountPaymentCompaniesArray
          ? accountPaymentCompaniesArray.map((x) => ({ value: x, text: x }))
          : [],
        filterRegex: true
      },
      {
        title: 'VID',
        key: 'studentId',
        dataIndex: 'studentId',
        sorter: true,
        searchTextName: 'VID',
      },
      {
        title: 'Receipt Number',
        key: 'receiptNumber',
        searchTextName: 'Receipt Number',
        render: (text, record) => (
          record.deleted == true ? <div style={{ padding: 10, backgroundColor: 'red', color: '#fff' }}>{record.receiptNumber}<br /><small>Reason:- {record.deleteReason ? record.deleteReason : "NA"}</small></div> : <div>{record.receiptNumber}</div>
        )
      },
      {
        title: 'Student Name',
        key: 'studentName',
        dataIndex: 'studentName',
        sorter: true,
        searchTextName: 'studentName',
      },
      {
        title: 'DOB',
        key: 'dob',
        dataIndex: 'dob',
        sorter: true,
        searchTextName: 'dob',
        render: (text, record) => {
          let Date = record.dob ? moment(record.dob, [dateFormat, 'DD-MM-YYYY']).format(dateFormat) : '';
          return (
            <div>{Date}</div>
          )
        }
      },
      {
        title: 'Passport Number',
        key: 'passportNo',
        dataIndex: 'passportNo',
        sorter: true,
        searchTextName: 'passportNo',
        render: (text, record) => (
          <div>{record.passportNo ? record.passportNo : "NA"}</div>
        )
      },
      {
        title: 'Student Mobile',
        key: 'studentMobile',
        dataIndex: 'studentMobile',
        sorter: true,
        searchTextName: 'studentMobile',
      },
      {
        title: 'Payment Mode',
        key: 'paymentType',
        filters: [{ text: 'Cash', value: 'Cash' }, { text: 'Transfer', value: 'Transfer' }],
        filterRegex: true
      },
      {
        title: 'Received Amount',
        key: 'totalAmount',
        searchTextName: 'Amount',
      },

      {
        title: 'Payment Details',
        key: 'paymentDetails',
        render: (text, record) => (
          <div>
            <strong>SubTotal:- </strong> {record && record.amount ? record.amount.toFixed(2) : 'NA'}<br />
            <strong>CGST:- </strong> {record && record.cgstRate ? record.cgstRate.toFixed(2) : 'NA'}<br />
            <strong>SGST:- </strong> {record && record.sgstRate ? record.sgstRate.toFixed(2) : 'NA'}<br />
            <strong>Grand Total:- </strong> {record && record.totalAmount ? record.totalAmount.toFixed(2) : 'NA'}
          </div>
        )
      },
      {
        title: 'Action',
        key: 'operation',
        width: '220px',
        render: (text, record) => (
          <div>
            {
              !record.submittedDate ?
                <React.Fragment>
                  <RightsWrapper myRight={'AccountPayments.edit'}>
                    <Tooltip title="Edit Account Payment">
                      <Button
                        className={styles.btn}
                        shape="circle"
                        onClick={() => {
                          this.setAccountPaymentDetailsData(record._id)
                        }}
                        icon="edit"
                      />
                    </Tooltip>
                  </RightsWrapper>
                  <RightsWrapper myRight={'AccountPayments.delete'}>
                    <Tooltip title="Delete Account Payment">
                      <Popconfirm
                        title="Are you sure delete this Account Payment?"
                        onConfirm={() => {
                          this.deleteAccountPaymentDetails({ _id: record._id })
                        }}
                        okText="Yes"
                        cancelText="No">
                        <Button
                          className={styles.btn}
                          shape="circle"
                          icon="delete"
                        />
                      </Popconfirm>
                    </Tooltip>
                  </RightsWrapper>
                </React.Fragment>
                : null
            }
            <React.Fragment>
              <RightsWrapper myRight={'AccountPayments.view'}>
                <Tooltip title="View Receipt">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    onClick={() => {
                      this.viewAccountPaymentReceipt(record._id)
                    }}
                    icon="eye"
                  />
                </Tooltip>
              </RightsWrapper>
              <RightsWrapper myRight={'AccountPayments.delete'}>
                <Tooltip title="Send Receipt To Student">
                  <Popconfirm
                    title="Are you sure, You want to sent this receipt to student?"
                    onConfirm={() => {
                      this.sendAccountPaymentReceipt({ _id: record._id })
                    }}
                    okText="Yes"
                    cancelText="No">
                    <Button
                      className={styles.btn}
                      shape="circle"
                      icon="forward"
                    />
                  </Popconfirm>
                </Tooltip>
              </RightsWrapper>
            </React.Fragment>
            {
              !record.approvedDate && !record.approvedByUser && record.submittedDate ?
                <React.Fragment>
                  <RightsWrapper myRight={'todayRegistrationFees.view'}>
                    <Tooltip title="Approve Payment">
                      <Button
                        className={styles.btn}
                        shape="circle"
                        onClick={() => {
                          this.approveAccountPayment(record._id)
                        }}
                        icon="check"
                      />
                    </Tooltip>

                  </RightsWrapper>

                </React.Fragment>

                : null
            }
            {
              !record.approvedDate && !record.approvedByUser ?
                <React.Fragment>
                  <Tooltip title="Request Update">
                    <Button
                      className={styles.btn}
                      shape="circle"
                      onClick={() => {
                        this.requestAccountUpdate(record._id);
                      }}
                      icon="reload"
                    />
                  </Tooltip>
                </React.Fragment>

                : null
            }
          </div>
        )
      }
    ]
    return (
      <PageHeaderWrapper title={` Account Payments  `}>
        {
          showAccountPaymentDrawar ?
            <ReceiptView recordId={recordId} onClose={this.closeDocument} />
            : null
        }

        {
          showRequestUpdationForm ?
            <RequestUpdationForm recordId={recordId} onClose={this.closeUpdationForm} />

            : null
        }
        <Card bordered={true}>
          <Row gutter={16}>
            <Col span={8}>
              <h4>Filter by Date</h4>
              <RangePicker
                defaultValue={[time.from, time.to]}
                format="YYYY-MM-DD"
                placeholder={['Start Date', 'End Date']}
                onChange={this.chooseRangerPicker}
                onOk={this.onOk}
              />
            </Col>
          </Row>
        </Card>
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All Account Payments`} key={0}>
              <Row>
                <Col span={20}><h2>{`Total : ${this.state.total}`}</h2></Col>
                <Col span={4}><h3>{`Total Amount : ${this.state.amountTotal}`}</h3></Col>
              </Row>

              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{ scroll: { x: 1500 } }}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>

            <TabPane tab={(id ? 'Edit' : 'Add') + ' Account Payment'} key={1}>
              <Form onSubmit={this.handleSubmit} style={{ marginTop: 8 }}>
                <GetAllFormFields
                  inputSchema={inputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{ marginBottom: 10, marginLeft: '1%' }}
                  loading={this.props.loading}
                  onClick={() => {
                    this.props.form.resetFields()
                  }}>
                  RESET
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllAccountPayments
